module.exports = __webpack_public_path__ + "static/media/l-md7.07fbe4de.png";